<template>
  <LogsComponent />
</template>

<script>
// @ is an alias to /src
import LogsComponent from "@/sections/voiceplus/components/LogsComponent.vue";
import config from "@/config";

export default {
  name: "Logs",
  components: {
    LogsComponent,
  },
  data: function () {
    return {
      sections: config.Sites,
    };
  },
};
</script>
